import { render } from "./ReviewNodeResultList.vue?vue&type=template&id=4e8be190&ts=true"
import script from "./ReviewNodeResultList.ts?vue&type=script&lang=ts&external"
export * from "./ReviewNodeResultList.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__